<template>
  <b-dropdown-item v-on:click="changeLanguage" href="#">{{ID}}</b-dropdown-item>
</template>

<script>
export default {
  name: "ttlp-language-entry",
  props: {
    ID: String
  },
  methods: {
    changeLanguage: function() {
      localStorage.setItem("Locale", this.ID);
      this.$i18n.locale = this.ID;
    }
  }
};
</script>